export const MAX_CRITERIA_TO_SHOW = 7
export const MAX_POST_SCREENER_QUESTIONS_TO_ANSWER = 10
export const MAX_POST_SCREENER_QUESTIONS_PER_TRIAL = 2

export const MAX_PRESCREENER_VERIFIER_QUESTIONS = 3

export const MAX_QUESTIONS_PER_APPLY_FLOW =
  MAX_CRITERIA_TO_SHOW +
  MAX_POST_SCREENER_QUESTIONS_TO_ANSWER +
  MAX_PRESCREENER_VERIFIER_QUESTIONS
